interface SectionTitleProps {
  title: string;
  subtitle?: string;
  align?: "left" | "center";
}

export default function SectionTitle({ title, subtitle, align = "left" }: SectionTitleProps) {
  return (
    <div className={align === "center" ? "text-center" : ""}>
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 text-balance">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-2xl text-balance">
          {subtitle}
        </p>
      )}
    </div>
  );
}